import { useApolloClient, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { LOGOUT_USER_MUTATION } from "../../graphql/mutations/user.mutation";
import { useContext } from "react";
import { UserContext } from "../../contexts/user.context";

const useLogout = () => {
  const { setUser } = useContext(UserContext);
  const client = useApolloClient();
  const navigate = useNavigate();
  const [logoutMutation] = useMutation(LOGOUT_USER_MUTATION);

  const logout = async () => {
    try {
      // Perform GraphQL mutation to logout if necessary
      // await client.mutate({ mutation: YOUR_LOGOUT_MUTATION });

      // Clear cache and reset store
      await logoutMutation();
      localStorage.removeItem("token");
      setUser(null);
      navigate("/login");
      await client.clearStore();
      await client.resetStore();

      // Redirect to login page or homepage after successful logout
    } catch (error) {
      console.error("Error during logout:", error);
      // Handle logout errors here
    }
  };

  return logout;
};

export default useLogout;
